const styles = () => ({
    centerProgress: {
        textAlign: 'center',
        minWidth: '800px',
    },
    containerForm: {
        maxWidth: '800px',
    },
    requestResult: {
        fontSize: '14px',
    },
});

export default styles;
